(function () {
    'use strict';

    angular
        .module('core.helpers')
        .service('ImagePathHelper', ImagePathHelper)

    /** @ngInject */
    function ImagePathHelper(ROUTES) {
        const ImagePathHelper = {
            imageHandlerPath,
            imageResizePath
        };

        return ImagePathHelper;

        function imageHandlerPath(area, id, file) {
            return `${ROUTES.API}/images/res/${area}/${id}/${file}`;
        }

        function imageResizePath(area, id, file, width, height) {
            return `${ROUTES.API}/images/res/${width}/${height}/${area}/${id}/${file}`;
        }
    }
}());